import React from 'react'
import './Home.css'
import { Link } from 'react-router-dom'
import { Stack, Typography, Button } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { TrendingFlat } from '@mui/icons-material'
import BlockFullImage1Col from 'src/components/Common/BlockFullImage1Col'

export default function FlashSale() {
  return (
    <BlockFullImage1Col
      logo='https://meteor.stullercloud.com/das/136871401?fmt=smart-alpha&wid=120'
      logoWidth={{ xs: 80, sm: 120 }}
      logoAlt='MatrixGold and CounterSketch'
      title={['home.flashSale.title']}
      bgColor='#120f1b'
      video='https://gemvision.com/Images/Flash_Sale_Banner_Video.mp4'
    >
      <Stack sx={{ mt: -4, alignItems: 'center' }}>
        <Typography variant='h2' sx={{ mt: { xs: 3, sm: 1 } }}>
          <FormattedMessage id='home.flashSale.discount' />
        </Typography>
        <Typography variant='h6' component='p' sx={{ mt: 3 }}>
          <FormattedMessage id='home.flashSale.dates' />
        </Typography>
        <Typography variant='body2' sx={{ mt: 0.5, opacity: 0.7, maxWidth: { xs: 300, sm: 400 } }}>
          <FormattedMessage id='home.flashSale.excluding' />
        </Typography>
        <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 4 }}>
          <Button
            size='large'
            variant='outlined'
            endIcon={<TrendingFlat />}
            component={Link}
            to='/store/matrixgold-3/with-rhinoceros'
            color='secondary'
            data-cy='home-banner-button'
          >
            <FormattedMessage id='common.buyProduct' values={{ product: 'MatrixGold' }} />
          </Button>
          <Button
            size='large'
            variant='outlined'
            endIcon={<TrendingFlat />}
            component={Link}
            to='/store/countersketch'
            color='secondary'
            data-cy='home-banner-button'
          >
            <FormattedMessage id='common.buyProduct' values={{ product: 'CounterSketch' }} />
          </Button>
        </Stack>
      </Stack>
    </BlockFullImage1Col>
  )
}
